// src/data.js
export const courses = [
  {
    id: 1,
    title: "Ethical Hacking / Pen Testing",
    description: "Learn network security, kali linux and penetration testing from scratch.",
    image: "/images/image1.png",
    color: "text-green-400",
    features: [
      "Kali Linux & Terminal Mastery",
      "Network Penetration Testing",
      "Web Application Security (OWASP Top 10)",
      "System Exploitation & Privilege Escalation"
    ],
    duration: "12 weeks",
    price: "24,999 PKR",
    hasCertificate: "Yes"
  },
  
  {
    id: 2,
    title: "Full Stack Web Development",
    description: "Master React, Node.js, and modern CSS to build stunning websites.",
    image: "/images/image2.png",
    color: "text-blue-400",
    features: [
      "React Hooks & State Management",
      "RESTful API Development",
      "Database Modeling with MongoDB",
      "Responsive UI with Tailwind CSS"
    ],
    duration: "28 Weeks",
    price: "34,999 PKR",
    hasCertificate: "Yes"
  },
  {
    id: 3,
    title: "Python for Beginners",
    description: "Start your programming journey with the most popular language today.",
    image: "/images/image3.png",
    color: "text-yellow-400",
    features: [
      "Python Syntax & Data Types",
      "Automation Scripts",
      "Introduction to Python Libraries",
      "Logic building Assignments"
    ],
    duration: "9 Weeks",
    price: "14,999 PKR",
    hasCertificate: "Yes"
  },
  {
  id: 4,
  title: "Windows Exploit Development",
  description: "Windows based vulnerabilities, buffer overflow, shellcode and real-world exploit development .",
  image: "/images/image4.png",
  color: "text-red-400",
  features: [
      "Buffer Overflow Vulnerabilities",
      "Writing Custom Shellcode",
      "Bypassing ASLR & DEP",
      "Debugging with x64dbg & Immunity"
    ],
    duration: "28 Weeks",
    price: "199,999 PKR",
    hasCertificate: "Yes"
}
];